<template>
  <div id="pers-tab1" name="hres32e-tab1" class="content-pers clearfix">
    <div class="col-xs-12 col-md-6 pull-left">  
      <div class="col-xs-12 card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic1">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRES32EC2']['20'] }}</div>
        </div>

        <div class="data-box clearfix" v-show="subTopic1">
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC2']['40'] }}</div>
            <div class="col-xs-7 data-input-stable">{{ dropdowns.codtitle[nowLang][detail.codtitle] }}</div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC2']['50'] }}</div>
            <div class="col-xs-7 data-input-stable">{{ detail.namet }}</div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC2']['60'] }}</div>
            <div class="col-xs-7 data-input-stable">{{ detail.lastt }}</div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC2']['80'] }}</div>
            <div class="col-xs-7 data-input-stable">{{ detail.namee }}</div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC2']['90'] }}</div>
            <div class="col-xs-7 data-input-stable">{{ detail.laste }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-md-6 pull-right">  
      <div class="col-xs-12 card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic2">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRES32EC2']['30'] }}</div>
        </div>

        <div class="data-box clearfix" v-show="subTopic2">
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC2']['40'] }}</div>
            <div class="col-xs-7 data-input">
              <hrms-dropdown  v-model="paramDetails.n_codtitle" 
                              :options="dropdowns.codtitle[nowLang]"
                              style="margin-bottom: 5px;" />
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC2']['50'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="n_namet" name="n_namet" 
                     v-model="paramDetails.n_namet"
                     maxlength="30" 
                     v-validate="'max:30'"
                     data-vv-name="n_namet"
                     data-vv-as="n_namet"
                     :has-error="errors.has('n_namet')" />
              <div class="text-error" v-show="errors.has('n_namet')">{{errors.first('n_namet')}}</div>
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC2']['60'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="n_lastt" name="n_lastt" 
                     v-model="paramDetails.n_lastt"
                     maxlength="30" 
                     v-validate="'max:30'"
                     data-vv-name="n_lastt"
                     data-vv-as="n_lastt"
                     :has-error="errors.has('n_lastt')" />
              <div class="text-error" v-show="errors.has('n_lastt')">{{errors.first('n_lastt')}}</div>
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC2']['80'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="n_namee" name="n_namee" 
                     v-model="paramDetails.n_namee"
                     maxlength="30" 
                     v-validate="'max:30'"
                     data-vv-name="n_namee"
                     data-vv-as="n_namee"
                     :has-error="errors.has('n_namee')" />
              <div class="text-error" v-show="errors.has('n_namee')">{{errors.first('n_namee')}}</div>
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC2']['90'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="n_laste" name="n_laste" 
                     v-model="paramDetails.n_laste"
                     maxlength="30" 
                     v-validate="'max:30'"
                     data-vv-name="n_laste"
                     data-vv-as="n_laste"
                     :has-error="errors.has('n_laste')" />
              <div class="text-error" v-show="errors.has('n_laste')">{{errors.first('n_laste')}}</div>
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC2']['70'] }}</div>
            <div class="col-xs-7 data-input">
              <textarea class="form-control textarea-text" 
                        id="desnote" name="desnote" 
                        v-model="paramDetails.desnote"
                        maxlength="30" 
                        v-validate="'max:30'"
                        data-vv-name="desnote"
                        data-vv-as="desnote"
                        :has-error="errors.has('desnote')"></textarea>
              <div class="text-error" v-show="errors.has('desnote')">{{errors.first('desnote')}}</div>
              <div class="remark-limit-character">{{ dispLimitLabel(30) }}</div> 
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 box-footer">
      <button type="button" class="btn bg-dark-gray" @click="togglePage(0)" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
      <button type="button" class="btn bg-color-skin" @click="callSave()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
    </div>

  </div>
</template>

<script>
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres32e-tab1',
  data () {
    return {
      subTopic1: true,
      subTopic2: true,
      paramDetails: {
        n_codtitle: this.detail.n_codtitle,
        n_namet: this.detail.n_namet,
        n_lastt: this.detail.n_lastt,
        n_namee: this.detail.n_namee,
        n_laste: this.detail.n_laste,
        desnote: this.detail.desnote
      }
    }
  },
  watch: {
    'paramDetails.n_namet' () {
      this.$validator.validate('n_namet', this.paramDetails.n_namet).catch(e => {})
    },
    'paramDetails.n_lastt' () {
      this.$validator.validate('n_lastt', this.paramDetails.n_lastt).catch(e => {})
    },
    'paramDetails.n_namee' () {
      this.$validator.validate('n_namee', this.paramDetails.n_namee).catch(e => {})
    },
    'paramDetails.n_laste' () {
      this.$validator.validate('n_laste', this.paramDetails.n_laste).catch(e => {})
    },
    'paramDetails.desnote' () {
      this.$validator.validate('desnote', this.paramDetails.desnote).catch(e => {})
    },
    detail () {
      this.paramDetails.n_codtitle = this.detail.n_codtitle
      this.paramDetails.n_namet = this.detail.n_namet
      this.paramDetails.n_lastt = this.detail.n_lastt
      this.paramDetails.n_namee = this.detail.n_namee
      this.paramDetails.n_laste = this.detail.n_laste
      this.paramDetails.desnote = this.detail.desnote
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    },
    toggleSubTopic2 () {
      this.subTopic2 = !this.subTopic2
    },
    saveParams () {
      return {
        n_codtitle: this.paramDetails.n_codtitle,
        n_namet: this.paramDetails.n_namet,
        n_lastt: this.paramDetails.n_lastt,
        n_namee: this.paramDetails.n_namee,
        n_laste: this.paramDetails.n_laste,
        desnote: this.paramDetails.desnote,
        numseq: this.indexSelected.numseq,
        dtereq: this.indexSelected.dtereq,
        typchg: this.indexSelected.typchg
      }
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postDetail1Save({ saveParams: this.saveParams(), searchIndex: this.searchIndex, togglePage: this.togglePage })
        }
      })
    }
  },
  props: [ 'nowLang', 'labels', 'dropdowns', 'detail', 'pcDisp', 'togglePage', 'labelsButton', 'postDetail1Save', 'indexSelected', 'searchIndex', 'validateStaappr' ]
}
</script>


// WEBPACK FOOTER //
// tab1.vue?2c841cad